<template>
  <i-select :value="value" :clearable="true" v-on="$listeners">
    <i-option
      v-for="sender in senders"
      :key="sender.id"
      :value="sender.name"
      :label="sender.name"
    />
  </i-select>
</template>

<script>
  import { SenderService } from '@mailer/services/SenderService';

  export default {
    props: {
      value: {
        type: [Array, String, Number],
        default: null
      }
    },

    data: () => ({
      senders: []
    }),

    created() {
      SenderService.getSelect().then(
        (response) => (this.senders = response?.filter((f) => f.status !== 'moderation'))
      );
    }
  };
</script>
